// extracted by mini-css-extract-plugin
export default {"TemplateLayout":"TemplateLayout_TemplateLayout__FvesK"};